export default {
   link:"https://api.minhaj.app",
  };

